import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { Button } from '../ui/button';
import { Loader2 } from 'lucide-react';

// Same grid treatment as TransactionTable (gridlines + zebra + grey header).
const GRID_CLASS = 'overflow-x-auto border border-slate-300 rounded-xl bg-card shadow-sm [&_td]:border-r [&_td]:border-slate-200/80 [&_td:last-child]:border-r-0 [&_th]:border-r [&_th]:border-slate-200 [&_th:last-child]:border-r-0 [&_tbody_tr]:border-b [&_tbody_tr]:border-slate-200 [&_tbody_tr:nth-child(even)]:bg-slate-50/50';

export const ReconItemsTable = ({ columns, rows, rowKey, rowTestId, rowClassName, testId = 'recon-items-grid' }) => (
  <div className={GRID_CLASS} data-testid={testId}>
    <Table className="text-sm">
      <TableHeader>
        <TableRow className="bg-slate-100 hover:bg-slate-100 border-b-2 border-slate-300 [&_th]:py-2.5 [&_th]:text-[11px] [&_th]:font-semibold [&_th]:uppercase [&_th]:tracking-wider [&_th]:text-slate-600">
          {columns.map((c) => (
            <TableHead key={c.key} className={c.headClassName || c.className}>{c.header}</TableHead>
          ))}
        </TableRow>
      </TableHeader>
      <TableBody>
        {rows.map((row, i) => (
          <TableRow
            key={rowKey ? rowKey(row, i) : i}
            data-testid={rowTestId ? rowTestId(row, i) : undefined}
            className={`align-middle hover:!bg-sky-50/70 transition-colors [&_td]:py-2.5 ${rowClassName ? rowClassName(row, i) || '' : ''}`}
          >
            {columns.map((c) => (
              <TableCell key={c.key} className={c.className}>{c.render(row, i)}</TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </div>
);

const TONES = {
  default: 'border-slate-300 text-slate-700 hover:bg-slate-100',
  link: 'border-sky-300 text-sky-800 bg-sky-50/60 hover:bg-sky-100',
  approve: 'border-emerald-300 text-emerald-800 bg-emerald-50/60 hover:bg-emerald-100',
  danger: 'border-rose-300 text-rose-700 hover:bg-rose-50',
};

export const ReconActionButton = ({ label, icon: Icon, onClick, testId, tone = 'default', busy, disabled, title }) => (
  <Button
    size="sm"
    variant="outline"
    onClick={onClick}
    disabled={disabled || busy}
    data-testid={testId}
    aria-label={label}
    title={title || label}
    className={`h-7 px-2 gap-1 text-[11px] font-medium whitespace-nowrap ${TONES[tone] || TONES.default}`}
  >
    {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : <Icon className="w-3 h-3" />}
    <span>{label}</span>
  </Button>
);

export const DirectionPill = ({ direction }) => {
  const isIn = direction === 'inflow';
  return (
    <span className={`shrink-0 inline-flex h-5 items-center rounded-full px-1.5 text-[10px] font-semibold uppercase tracking-wide ${isIn ? 'bg-emerald-100 text-emerald-700' : 'bg-rose-100 text-rose-700'}`}>
      {isIn ? 'In' : 'Out'}
    </span>
  );
};
